<template>
  <div class="page page-faq container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">

        <!-- <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive" />
        </div> -->

        <div class="column content content-main is-right" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="faqdata">
          <div class="title">
            {{ faqdata.title }}
          </div>
          <!-- <markdown v-if="faqdata.content" :source="faqdata.content" style="margin-top:45px;" /> -->
          <ul class="list" style="list-style:none;margin-left:0;margin-top:45px;">
            <li v-for="(faq, index) in faqs" :key="`${index}`">
              <div class="subtitle minimal-margin">
                {{ faq.title }}
              </div>
              <markdown v-if="faq.content" :source="faq.content" />
            </li>
          </ul>
          <!-- <div class="text">
            <ul class="list" style="list-style:none;margin-left:0;">
              <li>
                <div class="subtitle minimal-margin">
                  WHEN DO I REPORT? WHAT ARE YOUR OFFICE HOURS?
                </div>
                <div class="text">
                  CMS lets you decide! You are given a deadline to report each month. This information will be on your paperwork from court. Your deadline will either be the 5th, 10th, 15th, 20th, or  25th each month. You can report any day we are open.
                  If you wait until your deadline date and it falls on a day the office is closed, you have until the next business day to report.
                  The Martinez office is open for reports M-F from 9am-4:30pm and closed on Wednesdays.
                  The Thomson office is open for reports Monday, Thursday and Friday only from 9am-4:30pm.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  WHO IS MY PROBATION OFFICER?
                </div>
                <div class="text">
                  Your case does get assigned to an officer; however, when you report in person, you will see the first officer available in an effort to shorten your wait time in the office.
                  Generally, cases from McDuffie County Probate, Warren County Probate, and Warrenton Municipal are assigned to Amy Kitchens. 706-595-5657
                  Cases from Columbia County Probate are assigned by your last name.
                  A-L:  Samantha Gay (706-550-0411 ext.1)   M-Z:  Arlene Ormaza  (706-550-0411 ext 2) Web Reporting:  Amanda Barrow (706-550-0411 ext 4)
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  CAN I REPORT ONLINE?
                </div>
                <div class="text">
                  Web reporting is available for some cases. Ask how you can qualify.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  HOW DO I MAKE A PAYMENT?
                </div>
                <div class="text">
                  During your report:  Money Order or with debit/credit card (2.95% fee is charged by our processor or minimum of $2). The convenience fee is the charge of the 3rd party vendor. We receive NONE of the convenience fee.
                  You can pay online thru www.paycscd.com. You must have a PID# (personal identification #) for this site. Your officer can provide.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  HOW DO I COMPLETE COMMUNITY SERVICE?
                </div>
                <div class="text">
                  An officer will discuss community service at your first report.  You will be provided with a list of non-profit organizations in the community that have been approved by the court and can only complete hours at the site you are assigned.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  I JUST GOT NEW CHARGES/ARRESTED. WHAT HAPPENS NOW?
                </div>
                <div class="text">
                  Contact your probation officer immediately.  Bring any/all documentation to your office visit. Most often, you will be required to appear before the judge again for possible revocation of probation.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  CAN I TRAVEL OUT OF STATE WHILE ON MISDEMEANOR PROBATION?
                </div>
                <div class="text">
                  You are allowed to travel out of state on misdemeanor probation. Please advise your officer of travel plans and report by your deadline date.
                </div>
              </li>
              <li>
                <div class="subtitle minimal-margin">
                  HOW DO I RE-INSTATE MY LICENSE?
                </div>
                <div class="text">
                  Contact the Department of Driver Services of your licensing state.  Check Helpful Links for the state of Georgia.
                </div>
              </li>
            </ul>
          </div> -->
        </div>

        <!-- <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive is-hidden-mobile" />
          <div class="box color-gray-lighter-bg" v-if="false">
            <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div>
          </div>
        </div>

        <div class="column content is-hidden-tablet" style="margin-bottom:0;" v-if="false">
          <div class="box color-gray-lighter-bg">
            <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-faq',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      faqdata: undefined,
      faqs: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getFaqData()
    this.getFaqs()
  },
  methods: {
    async getFaqData () {
      try {
        let data
        // faq data
        this.faqdata = undefined
        data = await Site.aboutNamed('faq')
        if (data && data[0]) {
          data = data[0]
          this.faqdata = data
        }
      } catch (error) {
        console.log('faq error', error)
      }
    },

    async getFaqs () {
      try {
        let data
        // faq
        this.faqs = undefined
        data = await Site.faqs()
        if (data) {
          this.faqs = data
        }
      } catch (error) {
        console.log('faq error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-faq {
  .content {
    ul.list {
      li {
        margin-top: 30px;
      }
    }

    a {
      // text-decoration: underline;
      // color: $color-primary-blue;
      font-size: 1.0em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Faq.vue?99d591ae